import React from 'react';
import ReactDOM from 'react-dom';
import ReactTooltip from 'react-tooltip'
import { getFuelLabelClass } from '../../utils/fuelLabelColor';
import {
  canEditOpeningBalanceFields,
  formatOpeningBalanceDisplayDate,
  getOpeningBalanceMinDate,
  shouldShowOpeningBalanceDateField,
} from '../../utils/openingBalanceDate';
import OpeningBalanceUnlockButton from '../../utils/OpeningBalanceUnlockButton';

const DealershipModal = ({
  isShowing,
  list,
  success,
  hide,
  double,
  preventNonNumericalInput,
  prevNonNumericalWithDec,
  errors,
  inputValues,
  list_data,
  dropdownData,
  handleSubmit,
  handleInputs,
  handleInput,
  stat_operation,
  canEditOpeningBalance,
  onUnlockOpeningBalance,
  isOwnerRole,
}) => {
  const canEditOpeningFields = canEditOpeningBalanceFields({
    statOperation: stat_operation,
    openingBalanceUnlocked: canEditOpeningBalance,
  });
  const showOpeningBalanceFields = stat_operation !== "Yes" || canEditOpeningFields;
  const showOpeningBalanceDateField = shouldShowOpeningBalanceDateField({
    statOperation: stat_operation,
    openingBalanceUnlocked: canEditOpeningBalance,
  });

  const formatOpeningBalanceDisplay = (amount, debitCredit) => {
    const numericAmount = Number(amount || 0);
    const formattedAmount = numericAmount.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return debitCredit === "Dr" ? `(${formattedAmount})` : formattedAmount;
  };

  return (
    <React.Fragment>

      <div className="modal-overlay" />
      <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
        <div className="modal modalm" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
          <div className="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Dealership Configuration</h5>
            <div className="d-flex align-items-center gap-2">
              <OpeningBalanceUnlockButton
              statOperation={stat_operation}
              unlocked={Boolean(canEditOpeningBalance)}
              canUnlock={isOwnerRole}
              onUnlock={onUnlockOpeningBalance}
            />
              <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>Name</label>
            <input type="text" className="form-control " name="name" value={list_data.dealer_data ? list_data.dealer_data.dealer_name : ""} onChange={handleInputs} readOnly />
          </div>
          <div className="form-group">
            <label>Address</label>
            <input type="text" className="form-control" name="address" value={inputValues["address"]} onChange={handleInputs} />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input type="text" className="form-control hide-arrow ph_no" onKeyPress={(event) => prevNonNumericalWithDec(event, event.target.value)} name="phone" id={"phone"} value={inputValues["phone"]} onChange={handleInputs} />
            <div className="errorMsg">{errors.phone}</div>
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="text" className="form-control" name="email" value={inputValues["email"]} onChange={handleInputs} />
            <div className="errorMsg">{errors.email}</div>
          </div>

          <div className="form-group">
            <label>Product Name</label>
            <input type="text" className={`form-control ${getFuelLabelClass(list.fuel_name)}`} name="product_name" value={list.fuel_name} onChange={handleInputs} readOnly />
          </div>
          <div className="form-group">
            <label>Supply Terminal</label>
            <input type="text" className="form-control" name="supply_terminal" value={inputValues["supply_terminal"]} onChange={handleInputs} />
          </div>
          <div className="form-group">
            <label>Lead Time To Supply</label>
            <input type="number" min={0} max={100} className="form-control" onKeyPress={(event) => prevNonNumericalWithDec(event, inputValues["lead_time"])} name="lead_time" value={inputValues["lead_time"]} onChange={handleInputs} />
            <div className="errorMsg">{errors.lead_time}</div>
          </div>
          <p className="note">Note: Lead time to supply is a time taken to deliver fuel once order is placed.</p>

          {showOpeningBalanceFields && (
            <>
              <div className="row">
                <div className="col-md-8">
                  <div className="form-group">
                    <label>
                      Opening Balance
                      {stat_operation !== "Yes" ? <sup class="star">*</sup> : null}
                    </label>
                    <input
                      type="number"
                      className="form-control hide-arrow"
                      onKeyPress={(event) => preventNonNumericalInput(event, inputValues["opening_balance"])}
                      name="opening_balance"
                      id={"open"}
                      value={inputValues["opening_balance"]}
                      readOnly={!canEditOpeningFields}
                      onChange={handleInput}
                    />
                    <div className="errorMsg">{errors.opening_balance}</div>
                    {inputValues.opening_balance != null && (
                      <div className="errorMsg">{errors.debit_credit}</div>
                    )}
                    <span class="amount-words"></span>
                  </div>
                </div>
                <div className="col-md-4 mt-4 d-flex">
                  <div className="form-check col-sm pr-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      data-tip='Need to pay the party'
                      id="dealershipCreditRadio"
                      name="debit_credit"
                      value="Cr"
                      onChange={handleInputs}
                      checked={inputValues.debit_credit === 'Cr'}
                      disabled={!canEditOpeningFields}
                    />
                    <label className="form-check-label col-form-label" htmlFor="dealershipCreditRadio">
                      Credit
                    </label>
                    <ReactTooltip />
                  </div>
                  <div className="form-check col-sm pr-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      data-tip='Party to pay us'
                      id="dealershipDebitRadio"
                      name="debit_credit"
                      value="Dr"
                      onChange={handleInputs}
                      checked={inputValues.debit_credit === 'Dr'}
                      disabled={!canEditOpeningFields}
                    />
                    <label className="form-check-label col-form-label" htmlFor="dealershipDebitRadio">
                      Debit
                    </label>
                    <ReactTooltip />
                  </div>
                </div>
              </div>
              {showOpeningBalanceDateField && (
              <div className="form-group mb-3">
                <label>Opening Balance Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="ac_date"
                  value={inputValues.ac_date || ""}
                  min={getOpeningBalanceMinDate()}
                  onChange={handleInputs}
                  readOnly={!canEditOpeningFields}
                  disabled={!canEditOpeningFields}
                />
              </div>
              )}
            </>
          )}

          {Array.isArray(inputValues?.opening_balance_edit_history) && inputValues.opening_balance_edit_history.length > 0 && (
            <div className="mt-3">
              <h6 className="mb-2">Opening Balance Edit History</h6>
              <div className="table-responsive">
                <table className="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>Previous Value</th>
                      <th>Previous Date</th>
                      <th>New Value</th>
                      <th>New Date</th>
                      <th>Edited By</th>
                      <th>Edited At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inputValues.opening_balance_edit_history.map((log, idx) => (
                      <tr key={`ob-log-${idx}`}>
                        <td>{formatOpeningBalanceDisplay(log.previous_opening_balance, log.previous_debit_credit)}</td>
                        <td>{formatOpeningBalanceDisplayDate(log.previous_ac_date) || "—"}</td>
                        <td>{formatOpeningBalanceDisplay(log.new_opening_balance, log.new_debit_credit)}</td>
                        <td>{formatOpeningBalanceDisplayDate(log.new_ac_date) || "—"}</td>
                        <td>{log.edited_by || "Unknown"}</td>
                        <td>{log.edited_at ? new Date(log.edited_at).toLocaleString("en-IN") : "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div class="modal-footer">
            {double === true
              ? <button type="submit" class="btn btn-primary w-auto" onClick={handleSubmit}>SAVE DEALERSHIP CONFIGURATION</button>
              : <button type="submit" class="btn btn-primary w-auto" disabled>SAVE DEALERSHIP CONFIGURATION</button>}
          </div>

        </div>
      </div>
    </React.Fragment>
  );
}
export default DealershipModal;
